import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { getFieldIcon } from '../utils'

export const SocialMediaView = ({ field, value }) => {
  return (
    <Tooltip>
      <Tooltip.Trigger>
        <a
          href={value}
          target="_blank"
          rel="noreferrer noopener"
          className="w-6 h-6 flex-shrink-0 hover:opacity-80"
        >
          {getFieldIcon(field)}
        </a>
      </Tooltip.Trigger>
      <Tooltip.Panel>{field?.name}</Tooltip.Panel>
    </Tooltip>
  )
}
